var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"d-flex mb-2"},[_c('app-text-field',{attrs:{"clearable":"","icon":"$mdiMagnify","label":"Filter"},on:{"input":function($event){_vm.filter = $event}}})],1),_c('api-table',{staticClass:"mb-4",attrs:{"api-data":_vm.apiData,"field":_vm.section,"filter":_vm.filter}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }